import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'

import withStyles from '@material-ui/core/styles/withStyles'

const styles = theme => ({

})

/**
 * <DeleteTemplateDialog template onDeleteTemplate = {template} onCancel = {} />
 */

class DeleteTemplateDialog extends Component {

	render() {
		return <Dialog
			open = {true}
			scroll = "body"
		>
			<DialogTitle>
				Удалить шаблон
			</DialogTitle>
			<DialogContent style = {{display: "flex", flexDirection: "column"}}>
				Вы уверены, что хотите удалить шаблон &laquo;{this.props.template.name}&raquo;?
			</DialogContent>
			<DialogActions>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onDeleteTemplate === "function") {
							this.props.onDeleteTemplate(this.props.template)
						}
					}}
				>Удалить</Button>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>
			</DialogActions>
		</Dialog>

	}

}

export default withStyles(styles)(DeleteTemplateDialog)
